import { ReactElement, ReactNode } from 'react';

type GridProps = {
  items: ReactNode[];
  cols?: number | string;
  gap?: number | string;
  className?: string;
};

const CustomGrid = ({
  items,
  cols,
  gap,
  className,
}: GridProps): ReactElement => {
  return (
    <div className={`grid grid-cols-${cols} gap-${gap} ${className}`}>
      {items.map((item) => item)}
    </div>
  );
};

export default CustomGrid;
